export default function HeroSection() {
  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1f6a6cbe98f3ce82d76eb79054441f4c.jpg"
          alt="MOMAS D.O.O. Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/75" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-16 w-full pt-20">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-10">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-apple-fill text-[#D4FF00] text-sm" />
            </div>
            <span className="text-white/90 text-sm font-medium tracking-wide">iOS Development Experts</span>
          </div>

          {/* Headline */}
          <h1 className="text-[64px] leading-[1.08] font-bold text-white mb-8">
            Modern Applications<br />
            <span className="text-[#D4FF00]">for iOS Platform</span><br />
            Excellence
          </h1>

          {/* Subtext */}
          <p className="text-white/75 text-lg leading-relaxed max-w-xl mb-12">
            MOMAS D.O.O. is a team of experts developing modern applications
            for the iOS platform. Our products are designed to enhance user
            experience and improve the security of mobile devices.
          </p>

          {/* Scroll cue */}
          <a
            href="#about"
            onClick={(e) => handleNav(e, '#about')}
            className="inline-flex items-center gap-3 text-white/70 hover:text-white text-sm font-medium tracking-widest uppercase transition-colors duration-200 cursor-pointer"
          >
            <span>Discover More</span>
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-down-line text-lg" />
            </div>
          </a>
        </div>

        {/* Stats row */}
        <div className="mt-20 flex items-center gap-16 border-t border-white/15 pt-10 pb-10">
          {[
            { value: '99.9%', label: 'Uptime Guarantee' },
          ].map((stat) => (
            <div key={stat.label}>
              <div className="text-[#D4FF00] text-3xl font-bold">{stat.value}</div>
              <div className="text-white/60 text-sm mt-1 tracking-wide">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
